module.exports = __webpack_public_path__ + "static/media/Ecommerce-web.627aa7a7.png";